function path(root, sublink) {
  return `${root}${sublink}`;
}

export const AGRO_LAB_API_URL = process.env.REACT_APP_AGRO_LAB_API_URL;
export const PATH_AGROLAB_PAGE = process.env.REACT_APP_AGRO_LAB_PR_URL;

const ROOTS_AUTH = `/auth`;
const ROOTS_ECOMMERCE = `/e-commerce`
const ROOTS_MY_ACCOUNT = '/myAccount';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  resendCode: path(ROOTS_AUTH, '/resend-code')
};

export const PATH_ECOMMERCE = {
  eCommerce: {
    root: ROOTS_ECOMMERCE,
    shop: (bshopId) => path(ROOTS_ECOMMERCE, `/${bshopId}`),
    list: path(ROOTS_ECOMMERCE, '/list'),
    checkout: path(ROOTS_ECOMMERCE, '/checkout'),
    new: path(ROOTS_ECOMMERCE, '/product/new'),
    view: (id) => path(ROOTS_ECOMMERCE, `/product/${id}`),
    edit: (id) => path(ROOTS_ECOMMERCE, `/product/${id}/edit`),
  },
}

export const PATH_MY_ACCOUNT = {
  root: ROOTS_MY_ACCOUNT,
  account: path(ROOTS_MY_ACCOUNT, '/account'),
  purchased: {
    root:path(ROOTS_MY_ACCOUNT, '/purchased'),
    list: path(ROOTS_MY_ACCOUNT, '/purchased/list'),
    view: (orderNumber) => path(ROOTS_MY_ACCOUNT, `/purchased/${orderNumber}/view`),
  },
}

export const PATH_PAGE = {
  home: '/',
  marketHome: ROOTS_ECOMMERCE,
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  about: '/about-us',
  benefit: 'benefit',
  funcionality: 'funcionality',
  agroLabStamp: 'agrolabStamp',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};